module.exports = __webpack_public_path__ + "img/ss-2.9318cd53.png";